module.exports = __webpack_public_path__ + "static/img/vivo4.4048af1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/vivo/vivo4.png
// module id = POY3
// module chunks = 0